(function () {
  "use strict";
  var SHOP = "5135b9-3.myshopify.com";
  var EXPLICIT = /^\s*pin\s*[-:# ]?\s*(\d{4})\s*$/i;
  var DIGITS = /^\s*(\d{4})\s*$/;
  var PIN = /^\d{4}$/;
  var KEY = /^sk_[a-f0-9]{32}$/;
  var states = new WeakMap();
  var submitTokens = new WeakMap();
  var ready = false;
  var config;

  function parsePin(value) {
    var text = String(value == null ? "" : value);
    var match = EXPLICIT.exec(text);
    if (match) return { pin: match[1], explicit: true };
    match = DIGITS.exec(text);
    return match ? { pin: match[1], explicit: false } : null;
  }
  function safeProductUrl(win, value) {
    try {
      var url = new win.URL(value, win.location.origin);
      var canonicalHost = config && new win.URL(config.storefront).hostname;
      var cleanHost = function (host) { return host.replace(/^www\./i, "").toLowerCase(); };
      if (url.protocol !== "https:" && url.origin !== win.location.origin) return null;
      if (cleanHost(url.hostname) !== cleanHost(win.location.hostname) &&
          (!canonicalHost || cleanHost(url.hostname) !== cleanHost(canonicalHost))) return null;
      var match = /^(\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?)?(?:collections\/[a-z0-9][a-z0-9-]*\/)?products\/([a-z0-9][a-z0-9-]*)\/?$/i.exec(url.pathname);
      if (!match) return null;
      return url.origin + (match[1] || "/") + "products/" + match[2];
    } catch (_) { return null; }
  }
  function shareUrl(win, productPath, variantIds, selected) {
    var canonical = safeProductUrl(win, productPath);
    if (!canonical) throw new Error("Product link is unavailable.");
    var url = new win.URL(canonical);
    var variant = String(selected || new win.URL(win.location.href).searchParams.get("variant") || "");
    if (/^\d+$/.test(variant) && variantIds.indexOf(variant) !== -1) url.searchParams.set("variant", variant);
    return url.href;
  }
  function validResult(win, data, pin) {
    if (!data || data.pin !== pin || !PIN.test(data.pin) ||
        !/^\d+$/.test(String(data.productId)) || typeof data.title !== "string" ||
        !Number.isFinite(Date.parse(data.expiresAt)) || Date.parse(data.expiresAt) <= Date.now()) return null;
    var url = safeProductUrl(win, data.url);
    return url ? { url: url, title: data.title, pin: pin, expiresAt: data.expiresAt } : null;
  }
  function request(win, method, url, body, signal) {
    var controller = !signal && typeof win.AbortController === "function" ? new win.AbortController() : null;
    var timer;
    var timeout = new Promise(function (_, reject) {
      timer = win.setTimeout(function () {
        if (controller) controller.abort();
        reject(new Error("PIN service took too long. Please try again."));
      }, 8000);
    });
    var responsePromise = win.fetch(url, {
      method: method, mode: "cors", cache: "no-store", signal: signal || (controller && controller.signal),
      headers: { Accept: "application/json", ...(body ? { "Content-Type": "application/json" } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok) {
          var error = new Error(typeof data.error === "string" ? data.error : "PIN service unavailable (" + response.status + ").");
          error.status = response.status;
          throw error;
        }
        return data;
      });
    });
    return Promise.race([responsePromise, timeout]).finally(function () { win.clearTimeout(timer); });
  }
  function lookup(win, pin, signal) {
    return request(win, "GET", config.api + "/api/product-call-pins/" + pin +
      "?storeKey=" + encodeURIComponent(config.key), null, signal).then(function (data) {
      var product = validResult(win, data, pin);
      if (!product) throw new Error("PIN response was invalid or has expired. Please try again.");
      return product;
    });
  }
  function status(node, message) { node.textContent = message; }
  function showCopy(win, doc, host, value, feedback) {
    var field = host.querySelector("[data-so-manual-copy]");
    if (!field) {
      field = doc.createElement("input");
      field.type = "text";
      field.readOnly = true;
      field.setAttribute("aria-label", "Select and copy manually");
      field.setAttribute("data-so-manual-copy", "");
      host.appendChild(field);
    }
    field.value = value;
    field.hidden = false;
    field.focus();
    field.select();
    status(feedback, "Copy is unavailable here. Select and copy the text above manually.");
  }
  function copy(win, doc, host, value, feedback) {
    if (!win.navigator.clipboard || !win.navigator.clipboard.writeText) {
      showCopy(win, doc, host, value, feedback);
      return Promise.resolve(false);
    }
    return win.navigator.clipboard.writeText(value).then(function () {
      status(feedback, "Copied to clipboard.");
      return true;
    }, function () {
      showCopy(win, doc, host, value, feedback);
      return false;
    });
  }
  function initProduct(win, doc) {
    var root = doc.querySelector("[data-so-product-contact]");
    if (!root) return;
    var share = root.querySelector("[data-so-share]");
    var getPin = root.querySelector("[data-so-get-pin]");
    var copyPin = root.querySelector("[data-so-copy-pin]");
    var code = root.querySelector("[data-so-pin]");
    var expiry = root.querySelector("[data-so-expiry]");
    var feedback = root.querySelector("[data-so-feedback]");
    var manual = root.querySelector("[data-so-manual-copy]");
    if (ready) getPin.hidden = false;
    var variantIds = (root.getAttribute("data-variant-ids") || "").split(",");
    var currentPin = "";
    var expiresAt = 0;
    var expirationTimer;
    var token = 0;
    function clearPin() {
      currentPin = "";
      expiresAt = 0;
      code.textContent = "";
      expiry.textContent = "";
      code.parentNode.hidden = true;
      copyPin.hidden = true;
      if (manual) manual.hidden = true;
      win.clearTimeout(expirationTimer);
    }
    function selectedVariant() {
      var form = doc.querySelector('form[action*="/cart/add"]');
      var input = form && form.querySelector('[name="id"]');
      return input && variantIds.indexOf(String(input.value)) !== -1 ? String(input.value) : "";
    }
    function url() {
      return shareUrl(win, root.getAttribute("data-product-path"), variantIds, selectedVariant());
    }
    share.addEventListener("click", function () {
      var link;
      try { link = url(); } catch (e) { status(feedback, e.message); return; }
      if (typeof win.navigator.share === "function") {
        win.navigator.share({ title: root.getAttribute("data-product-title") || doc.title, url: link })
          .then(function () { status(feedback, "Product shared."); }, function (error) {
            if (error && error.name === "AbortError") {
              status(feedback, "Sharing cancelled.");
              return;
            }
            copy(win, doc, root, link, feedback);
          });
      } else copy(win, doc, root, link, feedback);
    });
    getPin.addEventListener("click", function () {
      clearPin();
      var operation = ++token;
      getPin.disabled = true;
      status(feedback, "Getting a call PIN…");
      request(win, "POST", config.api + "/api/product-call-pins", {
        storeKey: config.key, productId: root.getAttribute("data-product-id")
      }).then(function (data) {
        if (operation !== token) return;
        if (!PIN.test(data.pin) || String(data.productId) !== root.getAttribute("data-product-id") ||
            !Number.isFinite(Date.parse(data.expiresAt)) || Date.parse(data.expiresAt) <= Date.now()) {
          throw new Error("PIN response was invalid or expired. Please try again.");
        }
        currentPin = data.pin;
        expiresAt = Date.parse(data.expiresAt);
        code.parentNode.hidden = false;
        code.textContent = data.pin;
        expiry.textContent = "Expires at " + new Date(data.expiresAt).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" }) + " (30 minutes from issue).";
        copyPin.hidden = false;
        status(feedback, "Tell us this PIN when you call about this product.");
        expirationTimer = win.setTimeout(function () {
          if (operation !== token) return;
          clearPin();
          status(feedback, "This call PIN has expired. Get a new one to call about this product.");
        }, Math.max(0, Date.parse(data.expiresAt) - Date.now()));
      }).catch(function (error) {
        if (operation === token) status(feedback, error.message || "Could not get a PIN. Please try again.");
      }).finally(function () { if (operation === token) getPin.disabled = false; });
    });
    copyPin.addEventListener("click", function () {
      if (expiresAt && Date.now() >= expiresAt) {
        clearPin();
        status(feedback, "This call PIN has expired. Get a new one to call about this product.");
      } else if (currentPin) copy(win, doc, root, currentPin, feedback);
    });
    doc.addEventListener("visibilitychange", function () {
      if (expiresAt && Date.now() >= expiresAt) {
        clearPin();
        status(feedback, "This call PIN has expired. Get a new one to call about this product.");
      }
    });
    // Empire moves the AI widget asynchronously. Never anchor to it: its initial
    // location is outside the product grid and would create a third grid column.
    var purchase = doc.querySelector('.product-details form[action*="/cart/add"]');
    var actions = purchase && purchase.querySelector(".product-form--atc, .product-form__action-wrapper");
    var block = purchase && purchase.closest(".product-block--form");
    if (actions && actions.parentNode) actions.parentNode.insertBefore(root, actions);
    else if (block && block.parentNode) block.parentNode.insertBefore(root, block);
    else root.hidden = true; // Never show this section in the gallery/footer.
  }
  function isSearch(win, input) {
    if (!input || input.name !== "q" || !input.form) return false;
    try {
      var action = new win.URL(input.form.getAttribute("action") || "", win.location.origin);
      return action.origin === win.location.origin && /\/search\/?$/.test(action.pathname);
    } catch (_) { return false; }
  }
  function boxFor(win, doc, input, state) {
    if (state.box) return state.box;
    var box = doc.createElement("div");
    box.className = "so-pin-search";
    box.setAttribute("role", "status");
    box.setAttribute("aria-live", "polite");
    doc.body.appendChild(box);
    state.box = box;
    position(win, input, box);
    return box;
  }
  function position(win, input, box) {
    var rect = input.getBoundingClientRect();
    box.style.top = Math.max(0, rect.bottom + 4) + "px";
    var width = Math.min(Math.max(rect.width, 245), win.innerWidth - 16);
    box.style.left = Math.max(8, Math.min(rect.left, win.innerWidth - width - 8)) + "px";
    box.style.width = width + "px";
  }
  function clear(state) {
    if (!state) return;
    state.serial++;
    if (state.timer) clearTimeout(state.timer);
    if (state.controller) state.controller.abort();
    if (state.box) { state.box.remove(); state.box = null; }
    state.result = null;
  }
  function render(win, doc, input, state, product, message) {
    var box = boxFor(win, doc, input, state);
    box.replaceChildren();
    if (!product) status(box, message);
    else {
      var label = doc.createElement("span");
      label.textContent = "Call PIN match: ";
      var link = doc.createElement("a");
      link.href = product.url;
      link.textContent = product.title;
      box.appendChild(label);
      box.appendChild(link);
    }
    var parsed = parsePin(input.value);
    if (parsed) {
      var nativeLink = doc.createElement("a");
      var root = win.Shopify && win.Shopify.routes && win.Shopify.routes.root || "/";
      var search = new win.URL(root.replace(/\/?$/, "/") + "search", win.location.origin);
      search.searchParams.set("q", parsed.pin);
      search.searchParams.set("so_pin_native", "1");
      nativeLink.href = search.href;
      nativeLink.textContent = "Search products for " + parsed.pin + " instead";
      nativeLink.setAttribute("data-so-native-search", "");
      box.appendChild(nativeLink);
    }
  }
  function resolveSearchPage(win, doc) {
    var current = new win.URL(win.location.href);
    var root = win.Shopify && win.Shopify.routes && win.Shopify.routes.root || "/";
    if (current.pathname !== root.replace(/\/?$/, "/") + "search") return;
    if (current.searchParams.get("so_pin_native") === "1") return;
    var parsed = parsePin(current.searchParams.get("q"));
    if (!parsed) return;
    var input = doc.querySelector('form[action*="/search"] input[name="q"]');
    if (!isSearch(win, input)) return;
    var initial = input.value;
    lookup(win, parsed.pin).then(function (product) {
      if (input.value === initial && parsePin(input.value)?.pin === parsed.pin)
        win.location.replace(product.url);
    }, function (error) {
      if (input.value !== initial) return;
      var state = states.get(input) || { serial: 0, timer: null, controller: null, box: null, result: null };
      states.set(input, state);
      render(win, doc, input, state, null,
        error.status === 404 || error.status === 410 ? "PIN not found or expired. Ask for a new one." : error.message);
    });
  }
  function install(win, doc) {
    if (!win.Shopify || win.Shopify.shop !== SHOP) return false;
    var settings = doc.querySelector("[data-so-product-contact-config]");
    if (!settings) return false;
    var api = settings.getAttribute("data-api");
    var key = settings.getAttribute("data-store-key");
    var readiness = settings.getAttribute("data-readiness");
    var storefront = settings.getAttribute("data-storefront");
    if (!KEY.test(key || "") || api !== "https://shopbuild.pro" ||
        readiness !== api + "/api/product-call-pins/readiness" ||
        !/^https:\/\/(?:www\.)?buysgalore\.com$/.test(storefront || "")) return false;
    config = { api: api, key: key, storefront: storefront };
    // Search handlers are installed before theme capture handlers; until verified
    // production readiness, they leave native/BG search entirely untouched.
    doc.addEventListener("input", function (event) {
      var input = event.target;
      if (!isSearch(win, input)) return;
      var state = states.get(input);
      if (state) clear(state);
      var token = (submitTokens.get(input.form) || 0) + 1;
      submitTokens.set(input.form, token);
      if (!ready) return;
      var parsed = parsePin(input.value);
      if (!parsed) return;
      state = state || { serial: 0, timer: null, controller: null, box: null, result: null };
      states.set(input, state);
      var serial = state.serial;
      state.timer = win.setTimeout(function () {
        state.controller = new win.AbortController();
        lookup(win, parsed.pin, state.controller.signal).then(function (product) {
          if (state.serial !== serial || parsePin(input.value)?.pin !== parsed.pin) return;
          state.result = product;
          render(win, doc, input, state, product);
        }, function (error) {
          if (state.serial !== serial || error.name === "AbortError") return;
          render(win, doc, input, state, null,
            error.status === 404 || error.status === 410 ? "PIN not found or expired. Ask for a new one." : error.message);
        });
      }, 280);
    }, true);
    doc.addEventListener("submit", function (event) {
      if (!ready) return;
      var form = event.target;
      var input = form && form.querySelector && form.querySelector('input[name="q"]');
      if (!isSearch(win, input)) return;
      var parsed = parsePin(input.value);
      if (!parsed) return;
      var state = states.get(input);
      event.preventDefault();
      event.stopImmediatePropagation();
      var token = (submitTokens.get(form) || 0) + 1;
      submitTokens.set(form, token);
      if (state && state.result && state.result.pin === parsed.pin &&
          Date.parse(state.result.expiresAt) > Date.now()) {
        win.location.assign(state.result.url);
        return;
      }
      lookup(win, parsed.pin).then(function (product) {
        if (submitTokens.get(form) === token && parsePin(input.value)?.pin === parsed.pin) win.location.assign(product.url);
      }, function (error) {
        if (submitTokens.get(form) !== token) return;
        var current = states.get(input) || { serial: 0 };
        states.set(input, current);
        render(win, doc, input, current, null,
          error.status === 404 || error.status === 410 ? "PIN not found or expired. Ask for a new one." : error.message);
      });
    }, true);
    doc.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && isSearch(win, event.target)) clear(states.get(event.target));
    }, true);
    request(win, "GET", readiness + "?storeKey=" + encodeURIComponent(key)).then(function (data) {
      if (data && data.ready === true && data.version === 1) {
        ready = true;
        var button = doc.querySelector("[data-so-get-pin]");
        if (button) button.hidden = false;
        if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", function () {
          resolveSearchPage(win, doc);
        });
        else resolveSearchPage(win, doc);
      }
    }).catch(function () { /* Share remains usable without production PIN capability. */ });
    if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", function () { initProduct(win, doc); });
    else initProduct(win, doc);
    return true;
  }
  if (window.__SO_CONTACT_TEST__ === true) window.__SO_CONTACT_TEST_API__ = {
    parsePin: parsePin, safeProductUrl: safeProductUrl, shareUrl: shareUrl,
    validResult: validResult, install: install
  };
  install(window, document);
}());